import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { UserRole } from '@leedpulse-monorepo/enums';

interface UpdateCompanySubscriptionsPayload {
  company_id: string;
  id_subscriptions: Record<string, { updated: number }>;
}

interface UpdateCompanySubscriptionsResponse {
  company_id: string;
  id_subscriptions: Record<string, { updated: number }>;
  message?: string;
}

async function updateCompanySubscriptions(
  payload: UpdateCompanySubscriptionsPayload,
  auth: Authentication | null
): Promise<UpdateCompanySubscriptionsResponse> {
  if (!auth) {
    throw new UpdateCompanySubscriptionsFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');
  }

  if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
    throw new UpdateCompanySubscriptionsFailure('Unauthorized', 'unauthorized');
  }

  if (!payload.company_id?.trim()) {
    throw new UpdateCompanySubscriptionsFailure('company_id is required');
  }

  if (
    payload.id_subscriptions === null ||
    typeof payload.id_subscriptions !== 'object' ||
    Array.isArray(payload.id_subscriptions)
  ) {
    throw new UpdateCompanySubscriptionsFailure('id_subscriptions must be an object');
  }

  try {
    const response = await HttpClient.post(
      '/backoffice/companies/subscriptions/update',
      payload,
      auth.token
    );
    return (response?.data ?? response) as UpdateCompanySubscriptionsResponse;
  } catch (e) {
    const message = e instanceof Error ? e.message : 'Unknown error';
    throw new UpdateCompanySubscriptionsFailure(message);
  }
}

export class UpdateCompanySubscriptionsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default updateCompanySubscriptions;
